import classNames from "classnames";
import React, { type JSX } from "react";
import { Image } from "tsi-common-react/src/common/Image";
import { Link } from "tsi-common-react/src/common/Link";
import { t } from "ttag";

import { IDropdownMenuItem } from "../../menu.interface";

interface IProps {
    isActive: boolean;
    isMobile: boolean;
    linksArray: IDropdownMenuItem[];
    linkID: number;
}

export const DropdownLinks = ({
    isActive,
    isMobile,
    linksArray,
    linkID,
}: IProps): React.ReactNode => {
    const dropdownLinks = linksArray.map((obj, id) => {
        let badge: JSX.Element | null = null;
        if (obj.value.badge) {
            if (isMobile) {
                badge = (
                    <span>
                        <span className="menu-dropdown-badge menu-dropdown-badge--mobile">
                            {/* TODO(i18n): badge.mobile_text comes from CMS and should be translated there, not here */}
                            {obj.value.badge.mobile_text}
                        </span>
                    </span>
                );
            } else {
                badge = (
                    <span>
                        <Image
                            className={`menu-dropdown-badge menu-dropdown-badge--${obj.value.badge.position}`}
                            src={obj.value.badge.image.url}
                            // TODO(i18n): badge.mobile_text comes from CMS and should be translated there, not here
                            alt={obj.value.badge.mobile_text}
                        />
                    </span>
                );
            }
        }
        const titleClass = classNames({
            "menu-dropdown-block--lg-title": !isMobile,
            "menu-dropdown-block--sm-title": isMobile,
        });
        const pageURL =
            obj.type === "snippet_link" ? obj.value.link : obj.value.page.url;
        const target = obj.value.open_in_new_tab ? "_blank" : "_top";
        const rel = target === "_blank" ? "noopener noreferrer" : "";
        return (
            <Link
                key={id}
                href={pageURL}
                className="menu-dropdown-block"
                target={target}
                rel={rel}
                // TODO(i18n): override_title comes from CMS and should be translated there; use jt to keep sentence together: jt`Shop ${obj.value.override_title}`
                title={t`Shop ${obj.value.override_title}`}
            >
                {badge}
                <Image
                    className="menu-dropdown-block--image"
                    src={obj.value.image.url}
                    // TODO(i18n): image.title comes from CMS and should be translated there, not here
                    alt={obj.value.image.title}
                />
                {/* TODO(i18n): override_title comes from CMS and should be translated there, not here */}
                <p className={titleClass}>{obj.value.override_title}</p>
            </Link>
        );
    });
    const linkClass = classNames({
        "main-dropdown-menu__shop-links": true,
        "main-dropdown-menu__shop-links--mobile": isMobile,
        "main-dropdown-menu__shop-links--mobile-active": isMobile && isActive,
    });
    return (
        <div
            aria-expanded={isActive}
            className={linkClass}
            key={linkID}
            data-subnav={linkID}
        >
            {dropdownLinks}
        </div>
    );
};
